import { useEffect } from 'react';

/**
 * `enabled=true` の間だけ `beforeunload` イベントに preventDefault する listener を
 * 追加し、ブラウザネイティブの離脱確認ダイアログを表示させる。
 * pre-jobID 区間で誤って reload するのを防ぐために使う (設計 §4.2)。
 */
export function useBeforeUnloadGuard(enabled: boolean): void {
  useEffect(() => {
    if (!enabled) return;
    const handler = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      e.returnValue = '';
    };
    window.addEventListener('beforeunload', handler);
    return () => window.removeEventListener('beforeunload', handler);
  }, [enabled]);
}
